import React from 'react';
import { SectionHead } from './ui/SectionHead';
import { SectionReveal } from './ui/SectionReveal';
import { scopeBriefs } from '../data/scope';
export function Scope() {
  return <section id="scope" className="border-t border-rule py-[clamp(66px,9vw,114px)]" data-id="element-149" data-mp="1fsleepbe5aum">
      <div className="mx-auto max-w-shell px-[clamp(20px,5vw,64px)]" data-id="element-150" data-mp="1au1pcg1i3iy1">
        <SectionHead index="02" kicker="Scope" title="What I get called in for." intro="These are the five briefs that recur. If yours is not on the list it is probably a variation of one of them, and it is worth a conversation either way." data-id="element-151" data-mp="1arnx0ey7gku6" />

        <div className="mt-12 border-t border-ink" data-id="element-152" data-mp="wu91cshczgtr">
          {scopeBriefs.map((brief, i) => <SectionReveal key={brief.tag} delay={i * 0.04} className="grid grid-cols-1 items-start gap-2 border-b border-rule py-[26px] md:grid-cols-[170px_1fr] md:gap-x-[clamp(16px,3vw,48px)]" data-id="element-153" data-mp="rwqvjayn1hpz" data-mpi={i}>
              <p className="pt-[5px] font-mono text-[11px] uppercase tracking-[0.13em] text-signal" data-id="element-154" data-mp="16lm7p57tpboa">
                {brief.tag}
              </p>
              <div data-id="element-155" data-mp="1aos8hxc62and">
                <h3 className="mb-[9px] font-serif text-[clamp(20px,2.2vw,25px)] font-medium leading-[1.2] tracking-[-0.015em]" data-id="element-156" data-mp="wno8xnsc7whf">
                  {brief.title}
                </h3>
                <p className="max-w-[62ch] text-[15.5px] text-ink-70" data-id="element-157" data-mp="11ovi9ra4p3q7">
                  {brief.description}
                </p>
              </div>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}